export default "__VITE_ASSET__a065fd01__"